import {
  useColorMode as useChakraColorMode,
  useColorModeValue as useChakraColorModeValue,
} from '@chakra-ui/react';

export const useAppColorMode = useChakraColorMode;
export const useAppColorModeValue = useChakraColorModeValue;
